import script from "./TestGenerationView.vue?vue&type=script&setup=true&lang=js"
export * from "./TestGenerationView.vue?vue&type=script&setup=true&lang=js"

import "./TestGenerationView.vue?vue&type=style&index=0&id=5b58323e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b58323e"]])

export default __exports__